module.exports = __webpack_public_path__ + "static/media/bank-icon-orange.1eb6136f.svg";